import axios from "axios";
import React, { useEffect, useState } from "react";
import { headers } from "../../../exports/exports";
import { failed } from "../../../hooks/useToast";
import { useLoader } from "../../../context/LoaderContext";
import { IMemberListData } from "../../../exports/interfaces";
interface Operation {
  id: number;
  Operation_Name: string;
  No_Of_Cases: number;
  Observed: number;
  Assisted: number;
  Performed: number;
}

const OperationInfromation = (props: {
  listMemberData: IMemberListData[];
  memberId: number;
  getUserById: () => void;
}) => {
  const { setLoading } = useLoader();
  const [newOperation, setNewOperation] = useState<string>("");
  const [newCases, setNewCases] = useState<string>("0");
  const [newObserved, setNewObserved] = useState<string>("0");
  const [newAssisted, setNewAssisted] = useState<string>("0");
  const [newPerformed, setNewPerformed] = useState<string>("0");
  const [existingOperations, setExistingOperations] = useState<Operation[]>([]);

  useEffect(() => {
    if (props?.listMemberData?.[0]?.attributes?.frcsit_user_operations?.data) {
      const operations =
        props.listMemberData[0].attributes.frcsit_user_operations.data.map(
          (op) => ({
            id: op.id,
            Operation_Name: op.attributes.Operation_Name,
            No_Of_Cases: op.attributes.No_Of_Cases,
            Observed: op.attributes.Observed,
            Assisted: op.attributes.Assisted,
            Performed: op.attributes.Performed,
          })
        );
      setExistingOperations(operations);
    }
  }, [props?.listMemberData]);

  const handleExistingChange = (
    index: number,
    field: string,
    value: number
  ) => {
    setExistingOperations((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };
  const handleSubmit = async () => {
    setLoading(true);
    try {
      if (newOperation !== "") {
        setLoading(true);
        const data = {
          data: {
            Operation_Name: newOperation,
            be_frcsit_user: props.memberId,
            No_Of_Cases: Number(newCases),
            Observed: Number(newObserved),
            Assisted: Number(newAssisted),
            Performed: Number(newPerformed),
          },
        };
        axios.post(
          `${process.env.REACT_APP_strapiUrl}/api/frcsit-user-operations`,
          data,
          {
            headers: headers,
          }
        );
      }
      const originalOps =
        props?.listMemberData[0]?.attributes?.frcsit_user_operations?.data;

      const updatePromises = existingOperations.map(
        async (updatedOp, index) => {
          const original = originalOps[index].attributes;
          const isChanged =
            updatedOp.No_Of_Cases !== original.No_Of_Cases ||
            updatedOp.Observed !== original.Observed ||
            updatedOp.Assisted !== original.Assisted ||
            updatedOp.Performed !== original.Performed;

          if (isChanged) {
            const updateData = {
              data: {
                No_Of_Cases: updatedOp.No_Of_Cases,
                Observed: updatedOp.Observed,
                Assisted: updatedOp.Assisted,
                Performed: updatedOp.Performed,
              },
            };
            await axios.put(
              `${process.env.REACT_APP_strapiUrl}/api/frcsit-user-operations/${updatedOp.id}`,
              updateData,
              { headers }
            );
          }
        }
      );

      await Promise.all(updatePromises);
      setTimeout(() => {
        setNewOperation("");
        setNewCases("0");
        setNewObserved("0");
        setNewAssisted("0");
        setNewPerformed("0");
        setLoading(false);
        props.getUserById();
      }, 1000);
    } catch (error) {
      failed();
      setLoading(false);
    }
  };
  return (
    <>
      <div className="user-card__header">
        <div className="user-card__info" style={{ marginLeft: "unset" }}>
          <h3>Operation Information</h3>
          <p className="user-card__designation">
            Update your operation information
          </p>
        </div>
      </div>
      <hr />
      <div className="col-xl-12" style={{ marginBottom: "30px" }}>
        <table
          className="table cart-table custom-cart-table custom-cart-event-cell"
          style={{ marginBottom: "unset" }}
        >
          <thead>
            <tr>
              <th>#</th>
              <th style={{ width: "160px" }}>Operation</th>
              <th>No. of cases</th>
              <th>Observed</th>
              <th>Assisted</th>
              <th>Performed</th>
            </tr>
          </thead>
          <tbody>
            {props?.listMemberData[0]?.attributes?.frcsit_user_operations?.data?.map(
              (data, index) => (
                <tr key={index}>
                  <td style={{ overflowWrap: "break-word" }}>{index + 1}</td>
                  <td style={{ width: "160px" }}>
                    {data?.attributes?.Operation_Name}
                  </td>
                  <td style={{ overflowWrap: "break-word" }}>
                    <div className="col-xl-12">
                      <div
                        className="become-volunteer__input"
                        style={{ marginBottom: "unset" }}
                      >
                        <input
                          type="number"
                          name="cases"
                          style={{ padding: "0px 10px" }}
                          defaultValue={existingOperations[index]?.No_Of_Cases}
                          onChange={(e) =>
                            handleExistingChange(
                              index,
                              "No_Of_Cases",
                              Number(e.target.value)
                            )
                          }
                        />
                      </div>
                    </div>
                  </td>
                  <td style={{ overflowWrap: "break-word" }}>
                    <div className="col-xl-12">
                      <div
                        className="become-volunteer__input"
                        style={{ marginBottom: "unset" }}
                      >
                        <input
                          type="number"
                          name="observed"
                          style={{ padding: "0px 10px" }}
                          defaultValue={existingOperations[index]?.Observed}
                          onChange={(e) =>
                            handleExistingChange(
                              index,
                              "Observed",
                              Number(e.target.value)
                            )
                          }
                        />
                      </div>
                    </div>
                  </td>
                  <td style={{ overflowWrap: "break-word" }}>
                    <div className="col-xl-12">
                      <div
                        className="become-volunteer__input"
                        style={{ marginBottom: "unset" }}
                      >
                        <input
                          type="number"
                          name="assisted"
                          style={{ padding: "0px 10px" }}
                          defaultValue={existingOperations[index]?.Assisted}
                          onChange={(e) =>
                            handleExistingChange(
                              index,
                              "Assisted",
                              Number(e.target.value)
                            )
                          }
                        />
                      </div>
                    </div>
                  </td>
                  <td style={{ overflowWrap: "break-word" }}>
                    <div className="col-xl-12">
                      <div
                        className="become-volunteer__input"
                        style={{ marginBottom: "unset" }}
                      >
                        <input
                          type="number"
                          name="performed"
                          style={{ padding: "0px 10px" }}
                          defaultValue={existingOperations[index]?.Performed}
                          onChange={(e) =>
                            handleExistingChange(
                              index,
                              "Performed",
                              Number(e.target.value)
                            )
                          }
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              )
            )}
            <tr>
              <td style={{ overflowWrap: "break-word" }}>
                {props?.listMemberData[0]?.attributes?.frcsit_user_operations
                  ?.data?.length + 1}
              </td>
              <td style={{ width: "160px" }}>
                {" "}
                <div className="col-xl-12">
                  <div
                    className="become-volunteer__input"
                    style={{ marginBottom: "unset" }}
                  >
                    <input
                      type="text"
                      name="newopetation"
                      style={{ padding: "0px 10px" }}
                      value={newOperation}
                      onChange={(e) => setNewOperation(e.target.value)}
                    />
                  </div>
                </div>
              </td>
              <td style={{ overflowWrap: "break-word" }}>
                <div className="col-xl-12">
                  <div
                    className="become-volunteer__input"
                    style={{ marginBottom: "unset" }}
                  >
                    <input
                      type="number"
                      name="cases"
                      style={{ padding: "0px 10px" }}
                      value={newCases ?? ""}
                      onChange={(e) => setNewCases(e.target.value)}
                    />
                  </div>
                </div>
              </td>
              <td style={{ overflowWrap: "break-word" }}>
                <div className="col-xl-12">
                  <div
                    className="become-volunteer__input"
                    style={{ marginBottom: "unset" }}
                  >
                    <input
                      type="number"
                      name="observed"
                      style={{ padding: "0px 10px" }}
                      value={newObserved ?? ""}
                      onChange={(e) => setNewObserved(e.target.value)}
                    />
                  </div>
                </div>
              </td>
              <td style={{ overflowWrap: "break-word" }}>
                <div className="col-xl-12">
                  <div
                    className="become-volunteer__input"
                    style={{ marginBottom: "unset" }}
                  >
                    <input
                      type="number"
                      name="assisted"
                      style={{ padding: "0px 10px" }}
                      value={newAssisted ?? ""}
                      onChange={(e) => setNewAssisted(e.target.value)}
                    />
                  </div>
                </div>
              </td>
              <td style={{ overflowWrap: "break-word" }}>
                <div className="col-xl-12">
                  <div
                    className="become-volunteer__input"
                    style={{ marginBottom: "unset" }}
                  >
                    <input
                      type="number"
                      name="performed"
                      style={{ padding: "0px 10px" }}
                      value={newPerformed ?? ""}
                      onChange={(e) => setNewPerformed(e.target.value)}
                    />
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="become-volunteer__btn-box" style={{ textAlign: "end" }}>
        <button
          type="submit"
          className="thm-btn become-volunteer__btn become-volunteer__submit"
          onClick={() => handleSubmit()}
        >
          Submit
        </button>
      </div>
    </>
  );
};

export default OperationInfromation;
